import React from 'react';
import { Pagination as BootstrapPagination } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

const Pagination = ({ totalCount, limit, page, setPage }) => {
    const totalPages = Math.ceil(totalCount / limit);
    const pages = [];

    // Создаем массив страниц
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    if (totalPages <= 1) {
        return null; // Не показываем пагинацию если всего одна страница
    }

    return (
        <BootstrapPagination className="justify-content-center mt-4">
            <BootstrapPagination.Prev
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
            />
            
            {pages.map(p => (
                <BootstrapPagination.Item
                    key={p}
                    active={p === page}
                    onClick={() => setPage(p)}
                >
                    {p}
                </BootstrapPagination.Item>
            ))}
            
            <BootstrapPagination.Next
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
            />
        </BootstrapPagination>
    );
};

export default observer(Pagination);